import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { Chapters } from './components/Chapters';
import { Testimonials } from './components/Testimonials';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { Objections } from './components/Objections';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  // Inject Meta Pixel
  useEffect(() => {
    const pixelId = '1252242806993118';
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${pixelId}');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`;
    noscript.appendChild(img);
    document.head.appendChild(noscript);
    return () => {
      document.head.removeChild(script);
      document.head.removeChild(noscript);
    };
  }, []);
  return <div className="min-h-screen bg-brand-dark font-sans selection:bg-brand-pink selection:text-white" data-id="element-0">
      <Hero data-id="element-1" />
      <Chapters data-id="element-2" />
      <Testimonials data-id="element-3" />
      <Bonuses data-id="element-4" />
      <Pricing data-id="element-5" />
      <Objections data-id="element-6" />
      <PurchasePopup data-id="element-7" />

      <footer className="bg-brand-dark py-8 text-center text-zinc-500 text-sm border-t border-zinc-900" data-id="element-8">
        <p data-id="element-9">
          © {new Date().getFullYear()} Fútbol Femenino Elite System. Todos los
          derechos reservados.
        </p>
        <p className="mt-2" data-id="element-10">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
        </p>
      </footer>
    </div>;
}